import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-add-banner',
  templateUrl: './add-banner.component.html',
  styleUrls: ['./add-banner.component.scss']
})
export class AddBannerComponent extends FeaturesBaseComponent implements OnInit {
  bannerPromoForm: FormGroup;
  bannerPromoDetails: any;
  
  readonly:boolean = false;
  promoResponseDetails: any;
  fileToUpload: File = null;
   fileuploaded: boolean=false;
  uploadpic: boolean;
  minDate :Date = new Date();
  // selectedImageName: string;
  profilePicPath: any;
  constructor(private activeRoute: ActivatedRoute,
    private router: Router, 
    public dialog: MatDialog,
    private promotionService: PromotionsService) {
    super();
    
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    // this.toastrService.info('Banner Image will reflect after saving changes', 'Info', {
    //   timeOut: 3000,
    // });
    this.uploadpic = true;
   
    // this.selectedImageName = this.fileToUpload.name
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initbannerPromoForm();
         
  }
  initbannerPromoForm(){
    this.bannerPromoForm = new FormGroup({
      promotionName: new FormControl('', [Validators.required]),
      promitionDescription: new FormControl('', [Validators.required]),
      promocodeStartDate: new FormControl(''),
      promocodeEndDate: new FormControl(''),
      promotionImageUrl:new FormControl(''),
      displayBanner: new FormControl(''),
      imagePreview: new FormControl('')

    })
  }
  get f(){
    return this.bannerPromoForm.controls;
  }

  ngOnDestroy():void{
    super.ngOnDestroy()
  }
 

  onBannerFormSubmit(e){
    if (this.bannerPromoForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters()
        }else{
          this.router.navigate(['features/promotions/banner-config/manage-banner'])
        }
      });

    }
  }
  setSubmitParameters(){  
    const formData: FormData = new FormData();
    formData.append('promotionName', this.bannerPromoForm.get('promotionName').value);
    if (this.fileToUpload && this.fileToUpload){
      formData.append('promotionImage', this.fileToUpload)
    }else{
      formData.append('promotionImagePath', "https://imageblobs.blob.core.windows.net/carrierlogos/img01.jpg")
    }
    formData.append('promitionDescription', this.bannerPromoForm.get('promitionDescription').value);
    formData.append('promocodeStartDate', moment(this.bannerPromoForm.get('promocodeStartDate').value).format('MM/DD/YYYY'));
    formData.append('promocodeEndDate', moment(this.bannerPromoForm.get('promocodeEndDate').value).format('MM/DD/YYYY'));
    formData.append('displayBanner', this.bannerPromoForm.get('displayBanner').value==true ? 'Yes' : 'No');
    
    this.promotionService.addNewBanner(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.router.navigate(['features/promotions/banner-config/manage-banner'])
            this.toastrService.success('Promotion Banner added successfully', 'Success', {
              timeOut: 3000,
            });        
        }
        }

      }
    );
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/promotions/banner-config/manage-banner')
      }
    });
  }
  onCheckCertify(e){
  }
}   
